var _path, _path2, _g, _path3, _g2, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 24,
    viewBox: "0 0 146 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4667_622)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5603 0H24.5603C18.4803 0 13.4565 4.5216 12.668 10.3856L12.6684 10.3785C12.5345 11.4496 11.3659 11.9901 6.32339 12L0.560303 12V24C6.64041 24 11.6644 19.4781 12.4527 13.6139L12.4522 13.6216C12.6954 12.3243 13.7495 12 18.9116 12H12.5604V11.9998H24.5603V0ZM24.6273 23.9998L24.5603 24L24.4933 23.9998H24.6273Z",
    fill: "url(#paint0_linear_4667_622)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5101 10.8567C12.0553 11.6093 10.5537 11.9903 6.34055 11.9996H0.560602V23.9995C6.6401 23.9994 11.6637 19.4784 12.4527 13.6151L12.4523 13.6214C12.4679 13.538 12.4869 13.4587 12.5101 13.3832V10.8567ZM0.560529 -0.000488281L0.604318 -0.00041008H0.51674L0.560529 -0.000488281ZM-11.4395 11.9995L-11.4394 12.0422V11.9568L-11.4395 11.9995Z",
    fill: "url(#paint1_linear_4667_622)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    filter: "url(#filter0_f_4667_622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84668 19.0883C15.7214 19.0883 7.79531 14.1107 12.871 12.0008C16.8 10.3676 10.6061 4.43563 19.8661 4.92867",
    stroke: "url(#paint2_linear_4667_622)",
    strokeWidth: 1.72565
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4667_622",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.599 6.10352e-05L24.5603 0C18.4802 0 13.4563 4.52183 12.6679 10.386L12.6684 10.3782C12.5333 11.4593 11.3441 11.9998 6.18197 11.9998H12.5603V11.9999H0.560274V23.9999H0.512207L0.560335 24C6.64034 24 11.6642 19.4783 12.4527 13.6142L12.4522 13.6215C12.6923 12.341 13.7223 12.0084 18.713 12L24.5603 12V6.10352e-05H24.599ZM36.5603 12.0256L36.5603 12L36.5603 11.9744V12.0256Z",
    fill: "url(#paint3_linear_4667_622)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4667_622)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4667_622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.641357,
    y: 10.1689,
    width: 1.75646,
    height: 15.4384,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4667_622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.6716,
    y: -1.35596,
    width: 1.75646,
    height: 15.4384,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4667_622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.5474,
    y: 12.7266,
    width: 1.75646,
    height: 15.4384,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4667_622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.592,
    y: -4.59155,
    width: 1.75646,
    height: 15.4384,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79,
    filter: "url(#filter5_f_4667_622)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.791,
    y: 3.63599,
    width: 1.75646,
    height: 15.4384,
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2265 16.96V3.71753H41.71V5.72847H35.6254V9.32358H41.128V11.3345H35.6254V16.96H33.2265ZM49.4999 12.7829V7.02814H51.8406V16.96H49.5711V15.1947H49.4676C49.2434 15.7508 48.8749 16.2056 48.3619 16.5591C47.8532 16.9125 47.226 17.0893 46.4803 17.0893C45.8294 17.0893 45.2539 16.9449 44.7539 16.6561C44.2581 16.3629 43.8702 15.9383 43.59 15.3822C43.3098 14.8219 43.1697 14.1451 43.1697 13.3519V7.02814H45.5104V12.9898C45.5104 13.6192 45.6828 14.1192 46.0277 14.4899C46.3725 14.8607 46.8251 15.046 47.3855 15.046C47.7304 15.046 48.0645 14.962 48.3878 14.7938C48.7111 14.6257 48.9762 14.3757 49.1831 14.0438C49.3943 13.7075 49.4999 13.2873 49.4999 12.7829ZM56.5883 3.71753V16.96H54.2476V3.71753H56.5883ZM61.336 3.71753V16.96H58.9953V3.71753H61.336ZM65.1978 20.6844C64.8788 20.6844 64.5836 20.6585 64.312 20.6068C64.0447 20.5594 63.8313 20.5033 63.6718 20.4387L64.215 18.6153C64.5555 18.7144 64.8594 18.7618 65.1267 18.7575C65.394 18.7532 65.6289 18.6691 65.8315 18.5053C66.0384 18.3458 66.213 18.0786 66.3553 17.7036L66.5557 17.1669L62.9541 7.02814H65.4371L67.7261 14.5287H67.8295L70.1249 7.02814H72.6144L68.6378 18.1626C68.4524 18.6885 68.2067 19.139 67.9006 19.514C67.5946 19.8934 67.2195 20.1822 66.7755 20.3805C66.3359 20.5831 65.81 20.6844 65.1978 20.6844Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3376 16.96V3.71753H79.3035C80.3208 3.71753 81.1743 3.89427 81.864 4.24775C82.558 4.60122 83.0818 5.09695 83.4353 5.73493C83.7931 6.3686 83.9719 7.10789 83.9719 7.95278C83.9719 8.80199 83.7909 9.53911 83.4288 10.1642C83.071 10.7849 82.543 11.2655 81.8446 11.6061C81.1463 11.9423 80.2885 12.1104 79.2711 12.1104H75.7342V10.1189H78.9478C79.5427 10.1189 80.0298 10.037 80.4092 9.87319C80.7885 9.70508 81.0687 9.46152 81.2497 9.14253C81.4351 8.81923 81.5278 8.42265 81.5278 7.95278C81.5278 7.48292 81.4351 7.08202 81.2497 6.7501C81.0644 6.41387 80.782 6.15954 80.4027 5.98711C80.0234 5.81037 79.5341 5.722 78.9349 5.722H76.7365V16.96H74.3376ZM81.1786 10.9595L84.4569 16.96H81.78L78.5599 10.9595H81.1786ZM88.9346 17.1604C88.3053 17.1604 87.7384 17.0483 87.2341 16.8242C86.734 16.5957 86.3374 16.2595 86.0443 15.8155C85.7555 15.3715 85.6111 14.824 85.6111 14.1731C85.6111 13.6127 85.7145 13.1493 85.9215 12.7829C86.1284 12.4165 86.4107 12.1234 86.7685 11.9035C87.1263 11.6837 87.5293 11.5177 87.9777 11.4056C88.4303 11.2893 88.898 11.2052 89.3808 11.1535C89.9627 11.0931 90.4347 11.0392 90.7968 10.9918C91.1589 10.9401 91.4219 10.8625 91.5857 10.759C91.7538 10.6513 91.8379 10.4853 91.8379 10.2612V10.2224C91.8379 9.73525 91.6935 9.35807 91.4047 9.0908C91.1158 8.82354 90.6999 8.68991 90.1567 8.68991C89.5834 8.68991 89.1286 8.81492 88.7924 9.06494C88.4605 9.31496 88.2363 9.61024 88.1199 9.95078L85.9344 9.64041C86.1068 9.03692 86.3913 8.53257 86.7879 8.12736C87.1845 7.71785 87.6694 7.41179 88.2428 7.20919C88.8161 7.00228 89.4498 6.89882 90.1438 6.89882C90.6223 6.89882 91.0986 6.95486 91.5728 7.06694C92.0469 7.17901 92.4802 7.36437 92.8724 7.62301C93.2647 7.87734 93.5794 8.22435 93.8165 8.66404C94.0579 9.10373 94.1786 9.65335 94.1786 10.3129V16.96H91.9284V15.5956H91.8508C91.7086 15.8715 91.5081 16.1302 91.2495 16.3716C90.9951 16.6086 90.674 16.8005 90.286 16.947C89.9024 17.0893 89.4519 17.1604 88.9346 17.1604ZM89.5424 15.4404C90.0123 15.4404 90.4197 15.3478 90.7645 15.1624C91.1094 14.9727 91.3745 14.7227 91.5598 14.4123C91.7495 14.102 91.8443 13.7636 91.8443 13.3972V12.2268C91.7711 12.2872 91.6461 12.3432 91.4693 12.3949C91.2969 12.4467 91.1029 12.4919 90.8874 12.5307C90.6718 12.5695 90.4585 12.604 90.2472 12.6342C90.036 12.6644 89.8528 12.6902 89.6976 12.7118C89.3485 12.7592 89.0359 12.8368 88.76 12.9446C88.4842 13.0523 88.2665 13.2032 88.107 13.3972C87.9475 13.5868 87.8677 13.8326 87.8677 14.1343C87.8677 14.5654 88.0251 14.8908 88.3398 15.1107C88.6544 15.3305 89.0553 15.4404 89.5424 15.4404ZM96.5322 16.96V7.02814H98.7695V8.71577H98.8858C99.0928 8.14676 99.4355 7.70276 99.9139 7.38377C100.392 7.06047 100.964 6.89882 101.627 6.89882C102.3 6.89882 102.867 7.06262 103.328 7.39024C103.794 7.71354 104.121 8.15538 104.311 8.71577H104.414C104.634 8.164 105.005 7.72432 105.526 7.3967C106.052 7.06478 106.675 6.89882 107.395 6.89882C108.309 6.89882 109.055 7.18763 109.632 7.76527C110.21 8.3429 110.499 9.18564 110.499 10.2935V16.96H108.152V10.6556C108.152 10.0392 107.988 9.58869 107.66 9.30418C107.333 9.01537 106.932 8.87096 106.458 8.87096C105.893 8.87096 105.451 9.0477 105.132 9.40117C104.817 9.75034 104.66 10.2051 104.66 10.7655V16.96H102.365V10.5586C102.365 10.0456 102.209 9.6361 101.899 9.33005C101.593 9.02399 101.192 8.87096 100.696 8.87096C100.36 8.87096 100.054 8.95717 99.7782 9.1296C99.5023 9.29772 99.2824 9.53696 99.1186 9.84733C98.9548 10.1534 98.8729 10.5112 98.8729 10.9207V16.96H96.5322ZM112.873 20.6844V7.02814H115.175V8.67051H115.311C115.432 8.42911 115.602 8.17263 115.822 7.90105C116.042 7.62517 116.339 7.39024 116.714 7.19626C117.089 6.99796 117.568 6.89882 118.15 6.89882C118.917 6.89882 119.609 7.09495 120.225 7.48723C120.846 7.87519 121.338 8.45067 121.7 9.21366C122.066 9.97234 122.249 10.9034 122.249 12.007C122.249 13.0976 122.07 14.0244 121.713 14.7874C121.355 15.5504 120.868 16.1323 120.251 16.5332C119.635 16.9341 118.936 17.1345 118.156 17.1345C117.587 17.1345 117.115 17.0397 116.74 16.85C116.365 16.6604 116.063 16.4319 115.835 16.1646C115.611 15.8931 115.436 15.6366 115.311 15.3952H115.214V20.6844H112.873ZM115.169 11.994C115.169 12.6363 115.259 13.1989 115.441 13.6817C115.626 14.1645 115.891 14.5417 116.236 14.8132C116.585 15.0805 117.007 15.2141 117.503 15.2141C118.02 15.2141 118.454 15.0762 118.803 14.8003C119.152 14.5201 119.415 14.1386 119.592 13.6558C119.773 13.1687 119.863 12.6148 119.863 11.994C119.863 11.3776 119.775 10.8302 119.598 10.3517C119.421 9.87319 119.158 9.49816 118.809 9.22659C118.46 8.95502 118.025 8.81923 117.503 8.81923C117.003 8.81923 116.579 8.95071 116.229 9.21366C115.88 9.47661 115.615 9.84517 115.434 10.3193C115.257 10.7935 115.169 11.3518 115.169 11.994ZM128.651 17.1539C127.655 17.1539 126.795 16.947 126.071 16.5332C125.351 16.1151 124.797 15.5245 124.409 14.7615C124.021 13.9942 123.827 13.0911 123.827 12.0522C123.827 11.0306 124.021 10.134 124.409 9.36238C124.801 8.58645 125.349 7.98296 126.051 7.55189C126.754 7.11651 127.579 6.89882 128.528 6.89882C129.14 6.89882 129.717 6.99796 130.261 7.19626C130.808 7.39024 131.291 7.69198 131.709 8.1015C132.131 8.51102 132.463 9.03261 132.705 9.66628C132.946 10.2956 133.067 11.0457 133.067 11.9165V12.6342H124.926V11.0565H130.823C130.819 10.6082 130.722 10.2094 130.532 9.86026C130.343 9.50678 130.077 9.22874 129.737 9.02614C129.401 8.82354 129.008 8.72224 128.56 8.72224C128.082 8.72224 127.661 8.83863 127.299 9.0714C126.937 9.29987 126.655 9.60162 126.452 9.97665C126.254 10.3474 126.153 10.7547 126.148 11.1987V12.576C126.148 13.1536 126.254 13.6494 126.465 14.0632C126.676 14.4727 126.972 14.7874 127.351 15.0072C127.73 15.2228 128.174 15.3305 128.683 15.3305C129.023 15.3305 129.332 15.2831 129.608 15.1883C129.883 15.0891 130.123 14.9447 130.325 14.755C130.528 14.5654 130.681 14.3304 130.784 14.0502L132.97 14.296C132.832 14.8736 132.569 15.3779 132.181 15.809C131.797 16.2358 131.306 16.5677 130.707 16.8048C130.108 17.0376 129.422 17.1539 128.651 17.1539ZM138.733 17.1345C137.953 17.1345 137.254 16.9341 136.638 16.5332C136.021 16.1323 135.534 15.5504 135.176 14.7874C134.819 14.0244 134.64 13.0976 134.64 12.007C134.64 10.9034 134.821 9.97234 135.183 9.21366C135.549 8.45067 136.043 7.87519 136.664 7.48723C137.284 7.09495 137.976 6.89882 138.739 6.89882C139.321 6.89882 139.8 6.99796 140.175 7.19626C140.55 7.39024 140.847 7.62517 141.067 7.90105C141.287 8.17263 141.457 8.42911 141.578 8.67051H141.675V3.71753H144.022V16.96H141.72V15.3952H141.578C141.457 15.6366 141.283 15.8931 141.054 16.1646C140.826 16.4319 140.524 16.6604 140.149 16.85C139.774 17.0397 139.302 17.1345 138.733 17.1345ZM139.386 15.2141C139.882 15.2141 140.304 15.0805 140.653 14.8132C141.002 14.5417 141.267 14.1645 141.448 13.6817C141.63 13.1989 141.72 12.6363 141.72 11.994C141.72 11.3518 141.63 10.7935 141.448 10.3193C141.272 9.84517 141.009 9.47661 140.66 9.21366C140.315 8.95071 139.89 8.81923 139.386 8.81923C138.864 8.81923 138.429 8.95502 138.08 9.22659C137.731 9.49816 137.468 9.87319 137.291 10.3517C137.114 10.8302 137.026 11.3776 137.026 11.994C137.026 12.6148 137.114 13.1687 137.291 13.6558C137.472 14.1386 137.737 14.5201 138.086 14.8003C138.44 15.0762 138.873 15.2141 139.386 15.2141Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4667_622",
    x: 5.18266,
    y: 2.3726,
    width: 16.3932,
    height: 19.2426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.832009,
    result: "effect1_foregroundBlur_4667_622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4667_622",
    x: -3.39007,
    y: 7.42024,
    width: 7.25377,
    height: 20.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37435,
    result: "effect1_foregroundBlur_4667_622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4667_622",
    x: 20.9229,
    y: -4.10467,
    width: 7.25377,
    height: 20.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37435,
    result: "effect1_foregroundBlur_4667_622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4667_622",
    x: 9.79865,
    y: 9.97785,
    width: 7.25377,
    height: 20.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37435,
    result: "effect1_foregroundBlur_4667_622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4667_622",
    x: 8.84333,
    y: -7.34026,
    width: 7.25377,
    height: 20.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37435,
    result: "effect1_foregroundBlur_4667_622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_4667_622",
    x: 8.04231,
    y: 0.887276,
    width: 7.25377,
    height: 20.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37435,
    result: "effect1_foregroundBlur_4667_622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4667_622",
    x1: 12.5809,
    y1: 11.9871,
    x2: 16.9179,
    y2: 9.88218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4667_622",
    x1: 12.5232,
    y1: 2.40113,
    x2: -7.49601,
    y2: 25.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFD7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4667_622",
    x1: 12.4704,
    y1: 5.63624,
    x2: 12.4704,
    y2: 19.4888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4667_622",
    x1: 18.5169,
    y1: 11.9871,
    x2: 23.7681,
    y2: 8.16973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4667_622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.927,
    height: 24,
    fill: "white",
    transform: "translate(0.52002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.5d6264c5c33e607cfc76e2bf061cc73a.svg";
export { ForwardRef as ReactComponent };